import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { TextField, Button, Typography } from '@mui/material';
import Rating from 'react-star-rating-lite';
import ContentBox from '../layout/ContentBox';
import { showErrorNotification } from '../../redux/actions';
import ApiClient from '../../loopback/apiClient';

class FeedbackDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: '',
    };
  }

  onSubmit = () => {
    const { starRating, comment } = this.state;
    const {
      surveyId,
      onClose,
      submissionId,
      showErrorNotification: showErrorNotificationAction,
      surveySubmissionMetaId,
      trialVersion,
    } = this.props;
    const feedback = {
      rating: starRating,
      comment,
    };

    if (trialVersion === 2 && surveySubmissionMetaId) {
      feedback.digitalSurveyId = surveyId;
      ApiClient.submitFeedbackV2(feedback, surveySubmissionMetaId)
        .then(onClose())
        .catch((error) => showErrorNotificationAction(error.message));
    } else if (surveyId) {
      feedback.surveyId = surveyId;
      ApiClient.submitFeedback(feedback, submissionId)
        .then(onClose())
        .catch((error) => showErrorNotificationAction(error.message));
    }
  };

  render() {
    const { trialName, onClose } = this.props;
    const { starRating } = this.state;
    return (
      <ContentBox title={(
        <span>
          <FormattedMessage id="feedback.headline" />
          &nbsp;
          {trialName}
        </span>
      )}
      >
        <Typography variant="h6">
          <FormattedMessage id="feedback.titleIntro" values={{ trialName }} />
        </Typography>
        <Typography sx={{ my: '16px' }}>
          <FormattedMessage id="feedback.starRatingDescription" />
        </Typography>
        <Rating
          onClick={(value) => this.setState({ starRating: value })}
          weight={21}
        />
        <Typography sx={{ fontStyle: 'italic', my: '16px' }}>
          <FormattedMessage id="feedback.note" />
          <a href="mailto:office@quip.eu">office@quip.eu</a>
        </Typography>
        <TextField
          sx={{ width: '100%' }}
          label={<FormattedMessage id="feedback.textFieldHeading" />}
          onChange={(e) => this.setState({ comment: e.target.value })}
          multiline
          variant="standard"
        />
        <div className="mt4">
          <Button
            className="mr3"
            disabled={!starRating}
            onClick={this.onSubmit}
            variant="contained"
          >
            <FormattedMessage id="feedback.submitRating" />
          </Button>
          <Button
            style={{ marginLeft: '10px' }}
            onClick={onClose}
            variant="contained"
          >
            <FormattedMessage id="genericClose" />
          </Button>
        </div>
      </ContentBox>
    );
  }
}

FeedbackDialog.defaultProps = {
  trialVersion: null,
  submissionId: null,
  surveySubmissionMetaId: null,
};

FeedbackDialog.propTypes = {
  surveyId: PropTypes.number.isRequired,
  trialName: PropTypes.string.isRequired,
  trialVersion: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  submissionId: PropTypes.number,
  surveySubmissionMetaId: PropTypes.number,
  showErrorNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  showErrorNotification,
};

export default injectIntl(connect(null, mapDispatchToProps)(FeedbackDialog));
